<template>
	<div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
		<page-navigate></page-navigate>

	 <section class="fca1">
        <h1 class="cn-font-family-title">
          <span class="fca">FCA</span>流动性<br>清算账户开设流程
        </h1>
      </section>
      <section class="fca2">
        <img
          src="../assets/image/FCA/logo1.png"
          alt=""
          class="logo-img1 pc scroll-fade-left"
        />
        <img
          src="../assets/image/FCA/logo1_m.png"
          alt=""
          class="logo-img1 mobile scroll-fade-left"
        />
        <div class="fca2-content scroll-fade-right">
          <p>
            EBC Financial Group Limited
            是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商，所有交易订单直通国际清算池。监管编号：927552。
          </p>
          <p>
            在EBC Financial Group
            Limited开设FCA流动性清算账户，有权根据FSCS赔偿计划要求最高85000英镑的赔偿。 
          </p>
        </div>
      </section>
      <section class="fca3">
        <img
          src="../assets/image/FCA/logo2.png"
          alt=""
          class="logo-img2 pc scroll-fade-left"
        />
        <img
          src="../assets/image/FCA/logo2_m.png"
          alt=""
          class="logo-img2 mobile scroll-fade-left"
        />
        <div class="fca2-content scroll-fade-right">
          <p>
            欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID
            II根据客户的知识水平、经验和专长将投资者分为“零售投资者”或“专业投资者”等。
          </p>
          <p>
            根据FCA法规，EBC Financial Group Limited
            仅接受专业投资者和机构投资者，可开设杠杆为100倍的FCA流动性清算账户，投资者资金将独立托管于巴克莱银行隔离账户。
          </p>
        </div>
      </section>
      <section class="fca4">
        <h2 class="cn-font-family-title scroll-fade-up">
          专业投资者须满足以下三个<br class="mobile" />标准中的其中两个
        </h2>
        <div class="title-line"></div>
        <div class="fca4-content scroll-fade-up">
          <div class="fca4-item">
            <img
              src="../assets/image/FCA/section4Logo1.png"
              alt=""
              class="fca4-item-img"
            />
            <div class="fca4-item-text">过去一年平均交易频率<br class="pc">达到10次/季度</div>
          </div>
          <div class="fca4-item">
            <img
              src="../assets/image/FCA/section4Logo2.png"
              alt=""
              class="fca4-item-img"
            />
            <div class="fca4-item-text">
              持有超过50万欧元的投资组合，投资组合包括现金储蓄和金融工具
            </div>
          </div>
          <div class="fca4-item">
            <img
              src="../assets/image/FCA/section4Logo3.png"
              alt=""
              class="fca4-item-img"
            />
            <div class="fca4-item-text">
              在金融行业工作或至少工作过一年，了解差价合约或衍生品交易
            </div>
          </div>
        </div>
      </section>
      <section class="fca5">
        <h2 class="cn-font-family-title scroll-fade-up">
          FCA 流动性清算账户<br class="mobile" />开户流程
        </h2>
        <div class="title-line"></div>
        <div class="fca5-content fca5-seq scroll-fade-up" data-fca5-seq="1">
          <div class="fca5-item">
            <img
              src="../assets/image/FCA/section5Logo1.svg"
              alt=""
              class="fca5-item-img"
              data-fca5-svg
            />
            <p class="p1 cn-font-family-title">获取申请表</p>
            <p class="p2">访EBC英国站，获取申请表</p>
          </div>
          <div class="fca5-line" aria-hidden="true"></div>
          <div class="fca5-item">
            <img
              src="../assets/image/FCA/section5Logo2.svg"
              alt=""
              class="fca5-item-img"
              data-fca5-svg
            />
            <p class="p1 cn-font-family-title">提交材料</p>
            <p class="p2">按要求填写、上传申请材料</p>
          </div>
          <div class="fca5-line" aria-hidden="true"></div>
          <div class="fca5-item">
            <img
              src="../assets/image/FCA/section5Logo3.svg"
              alt=""
              class="fca5-item-img"
              data-fca5-svg
            />
            <p class="p1 cn-font-family-title">合规审核</p>
            <p class="p2">等待合规审核，签署相关文件</p>
          </div>
          <div class="fca5-line" aria-hidden="true"></div>
          <div class="fca5-item">
            <img
              src="../assets/image/FCA/section5Logo4.svg"
              alt=""
              class="fca5-item-img"
              data-fca5-svg
            />
            <p class="p1 cn-font-family-title">开户成功</p>
            <p class="p2">登录并设置您的FCA账户</p>
          </div>
        </div>
        <a href="https://ebcfin.co.uk/" class="primary-default_large scroll-fade-up" target="_blank">
          获取申请表
        </a>
      </section>
      <section class="fca6">
        <h2 class="cn-font-family-title scroll-fade-up">
          开设FCA流动性清算账户<br />
          最权威的监管保护和最安全的<br class="mobile" />资金保障
        </h2>
        <div class="title-line"></div>
        <img class="fca6-img pc scroll-fade-up" src="../assets/image/FCA/section6ModelZh.png" alt="" />
        <img
          class="fca6-img mobile scroll-fade-up"
          src="../assets/image/FCA/section6ModelMZh.png"
          alt=""
        />
        <div class="fca6-content scroll-fade-up">
          <p class="p1 cn-font-family-title">英国金融市场行为管理局（FCA）</p>
          <p class="p2">
            FCA流动性清算账户咨询邮箱：
            <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>
          </p>
        </div>
      </section>
      <message-v3></message-v3>
		<page-footer></page-footer>
	</div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";

export default {
    mixins: [fadeAnimate],
	data() {
		return {
			imgPath: this.$t('common.requestLang') == 'zh_CN' ? require('../assets/image/FCA/fca6.png') : require('../assets/image/FCA/fca6_en.png'),
			img_m_Path: this.$t('common.requestLang') == 'zh_CN' ? require('../assets/image/FCA/fca6-m.png') : require('../assets/image/FCA/fca6-m_en.png')
		}
	},
  mounted(){
    // window.__lc = window.__lc || {};
//     window.__lc.license = 12340599;
//     ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))

const fca1Element = document.querySelector('.fca1');
if (fca1Element) {
  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observerInstance.unobserve(entry.target);
        }
      });
    },
    {
      // threshold: 0.2 表示元素露出 20% 时触发动画，你可以根据需求调整
      threshold: 0.2,
    },
  );

  observer.observe(fca1Element);
}

/**
 * FCA section5: SVG 依次点亮（含虚线）-> 全部变灰 -> 循环
 */
(function initFca5Sequence() {
  const root = document.querySelector('.fca5-content.fca5-seq[data-fca5-seq]');
  if (!root) return;

  if (window.location.href.indexOf('/ar/') !== -1) {
    root.classList.add('is-ar');
  }

  const items = Array.from(root.querySelectorAll('.fca5-item'));
  const lines = Array.from(root.querySelectorAll('.fca5-line'));
  if (items.length < 2 || lines.length !== items.length - 1) return;

  function tagInlineSvg(svg) {
    const paths = Array.from(svg.querySelectorAll('path'));
    paths.forEach((p) => {
      const fill = (p.getAttribute('fill') || '').toLowerCase();
      const stroke = (p.getAttribute('stroke') || '').toLowerCase();

      // 数字：通常是 #6a6967 或 white
      if (fill === '#6a6967' || fill === 'white' || fill === '#ffffff') {
        p.classList.add('fca5-svg-number');
        return;
      }

      // 外圈：有 stroke 且 stroke-width
      if (stroke && p.getAttribute('stroke-width')) {
        p.classList.add('fca5-svg-ring');
        return;
      }

      // 核心：其余非空 fill 视为核心区域
      if (fill && fill !== 'none') {
        p.classList.add('fca5-svg-core');
      }
    });
  }

  async function inlineSvgs() {
    const imgs = Array.from(root.querySelectorAll('img.fca5-item-img[data-fca5-svg]'));
    await Promise.all(
      imgs.map(async (img) => {
        try {
          const res = await fetch(img.src, { cache: 'force-cache' });
          if (!res.ok) return;
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
          const svg = doc.querySelector('svg');
          if (!svg) return;

          // 保留展示尺寸/布局
          svg.setAttribute('focusable', 'false');
          svg.setAttribute('aria-hidden', 'true');

          tagInlineSvg(svg);
          img.replaceWith(svg);
        } catch (_) {
          // ignore: fallback to <img>
        }
      }),
    );
  }

  function render(activeItems, activeLines) {
    items.forEach((el, i) => el.classList.toggle('is-active', i < activeItems));
    lines.forEach((el, i) => el.classList.toggle('is-active', i < activeLines));
  }

  function resetInstantly() {
    root.classList.add('is-resetting');
    render(0, 0);
    // Force style flush so the reset happens without transition before re-enabling animation.
    void root.offsetHeight;
    root.classList.remove('is-resetting');
  }

  // timing 可按需要微调
  const iconDelayMs = 2400;
  const lineDelayMs = 2400;
  const fullHoldMs = 3600;
  const grayHoldMs = 2400;

  let timer = null;

  function clearTimer() {
    if (timer) window.clearTimeout(timer);
    timer = null;
  }

  function loop() {
    clearTimer();
    resetInstantly();

    let activeItems = 0;
    let activeLines = 0;

    const activateItem = () => {
      activeItems += 1;
      render(activeItems, activeLines);

      if (activeItems > lines.length) {
        timer = window.setTimeout(() => {
          resetInstantly();
          timer = window.setTimeout(loop, grayHoldMs);
        }, fullHoldMs);
        return;
      }

      // 当前图标完全点亮后，再点亮它后面的虚线
      timer = window.setTimeout(activateLine, iconDelayMs);
    };

    const activateLine = () => {
      activeLines += 1;
      render(activeItems, activeLines);

      // 当前虚线完全点亮后，再点亮下一个图标
      timer = window.setTimeout(activateItem, lineDelayMs);
    };

    timer = window.setTimeout(activateItem, 200);
  }

  // 初始全部灰，等 SVG 内联后再开始动画（避免先动后替换）
  resetInstantly();
  inlineSvgs().finally(loop);
})();
  }
}
</script>

<style lang="scss" scoped>
.contentBox {
  width: 1200rem;
  margin-inline: auto;
}
@media (max-width: 996px) {
  .contentBox {
    max-width: 100%;
    padding-inline: 32rem;
  }
}
a,
a:visited,
a:active {
  text-decoration: none;
}

a::before {
  content: none;
}
.fca1 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 120rem;
  height: 900rem;
 position: relative; 
  overflow: hidden;
}
/* 使用伪元素承载背景图 */
.fca1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../assets/image/FCA/section1Bg.webp);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; 
  z-index: -1; 
  transform: scale(1);
  transition: transform 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fca1.is-visible::before {
  transform: scale(1.1); 
}
.fca1 h1 {
  color: #fff;
  font-size: 72rem;
  font-weight: 700;
  line-height: 80rem;
  width: 1200rem;
  margin-inline: auto;
}

.fca2 {
  display: flex;
  align-items: center;
  padding: 120rem 0rem;
  max-width: 1200rem;
  margin-inline: auto;
  justify-content: space-between;
}
.fca3 .logo-img2,
.fca2 .logo-img1 {
  width: auto;
  height: 73rem;
}

.fca2-content {
  max-width: 454rem;
  color: #000;
  font-size: 20rem;
  font-weight: 400;
  line-height: 28rem; /* 206.25% */
}
.fca2-content p + p {
  margin-top: 20rem;
}

.fca3 {
  display: flex;
  align-items: center;
  padding: 120rem calc(50vw - 600rem);
  
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    rgba(246, 246, 246, 0.5) 0%,
    rgba(217, 217, 217, 0) 100%
  );
}


.fca3-content {
  max-width: 454rem;
  color: #000;
  font-size: 14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 22rem; 
}
.fca3 .fca2-content p + p {
  margin-top: 0rem;
}
.fca4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem calc(50vw - 600rem);
}
.fca4 h2,
.fca5 h2,
.fca6 h2{
  color: var(--Text-Primary, #000);
  text-align: center;
  font-size: 40rem;
  font-style: normal;
  font-weight: 700;
  line-height: 48rem; /* 120% */
}
.title-line {
   margin-bottom: 64rem;
}

.fca4-content {
  display: flex;
  justify-content: space-around;
  gap: 24rem;
  width: 100%;
}
.fca4-item {
  flex-shrink: 0;
  display: flex;
  gap: 28rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40rem;
  flex: 1;
  border-radius: var(--Corner-Radius-RC24, 24px);
  background: var(--Neutral-BG_B, #F7F7F7);
  transition: transform .3s;
}
.fca4-item:hover{
  transform: translateY(-30rem);
}
.fca4-item:nth-child(1) .fca4-item-img {
  width: 149rem;
  height: auto;
}
.fca4-item:nth-child(2) .fca4-item-img {
  width: 136rem;
  height: auto;
}
.fca4-item:nth-child(3) .fca4-item-img {
  width: 172rem;
  height: auto;
}
.fca4-item-text {
 color: var(--Text-Primary, #000);
  text-align: center;
  font-size: 14rem;
  font-weight: 400;
  line-height: 22rem; /* 157.143% */
}


.fca5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem 270rem;
  background: linear-gradient(
    90deg,
    rgba(246, 246, 246, 0.5) 0%,
    rgba(217, 217, 217, 0) 100%
  );
}

.fca5-content {
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 110rem;
  align-items: flex-start;
  width: 1200rem;
  max-width: 100%;
}

.fca5-item {
  width: 284rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fca5-item-img {
  width: 68rem;
  height: 68rem;
  margin-bottom: 25rem;
}



.fca5-item .p1 {
  color: #000;
  text-align: center;
  font-size: 24rem;
  font-weight: 700;
  line-height: 28rem;
  min-width: 284rem;
}
/* .en .fca5-item .p1{
  min-height: 56rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} */
.fca5-item .p2 {
  margin-top: 8rem;
  color: rgba(0, 0, 0, 0.64);
  text-align: center;
  font-size: 14rem;
  font-weight: 400;
  line-height: normal;
  min-width: 284rem;
}

.fca5-content.fca5-seq .fca5-item .p1,
.fca5-content.fca5-seq .fca5-item .p2 {
  color: rgba(0, 0, 0, 0.48);
  transition: color 2400ms ease;
}

.fca5-content.fca5-seq .fca5-item.is-active .p1 {
  color: #000;
}

.fca5-content.fca5-seq .fca5-item.is-active .p2 {
  color: rgba(0, 0, 0, 0.64);
}

.fca5 a {
  min-width: 160rem;
  color: #fff!important;
}
.btn:hover {
  color: #fff;
  background-color: #a52933;
}

.fca6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem 270rem;
}
.fca6-img {
  width: 1180rem;
}
.fca6-content {
  /* padding-left: 242rem; */
  margin-left: 245rem;
}

.fca6-content .p1 {
  margin-top: 24rem;
  color: #000;
  text-align: center;
  font-size: 18rem;
  font-weight: 500;
  line-height: 26rem; 
}
.fca6-content .p2 {
  margin-top: 4rem;
  color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
text-align: center;
font-size: 16rem;
font-weight: 400;
line-height: 28rem; /* 175% */
}
.fca6-content .p2 a {
   color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
}
@media (max-width: 996px) {
  .fca1 {
    height: 1200rem;
    padding: 0 32rem 160rem;
    align-items: flex-end;
  }
.fca1.is-visible::before {
  transform: scale(1.1); 
}
.fca1::before {
  background-image: url(../assets/image/FCA/section1BgM.webp);
}
  .fca1 h1 {
    text-align: center;
    font-size: 64rem;
    line-height: 80rem;
  }

  .fca3,
  .fca2 {
    padding: 80rem 64rem;
    flex-direction: column;
    gap: 48rem;
  }
  .fca2-content {
    max-width: unset;
    font-size: 28rem;
    padding: 0 ;
    line-height: normal;
  }
  .fca2-content p + p{
    margin-top: 40rem;
  }
  .fca2 .logo-img1,
  .fca3 .logo-img2 {
    width: auto;
    height: 96rem;
  }
  .fca5,
  .fca6,
  .fca4 {
    padding: 80rem 32rem;
  }

  .fca6 h2,
  .fca5 h2,
  .fca4 h2 {
    font-size: 48rem;
    line-height: normal;
  }

  .title-line {
    margin-bottom: 80rem;  
  }
  .fca4-item{
    flex-direction: row;
    gap: 48rem;
    padding: 48rem 42rem;
    border-radius: 12px;
  }
  .fca4-item-img{
    width: 130rem!important;
    height: auto!important;
  }
  .fca4-content {
    flex-direction: column;
  }
  .en .fca4-item-text,
  .fca4-item-text {
    font-size: 28rem;
    line-height: 44rem;
    text-align: left;
  }
  


  .fca5-item .p1{
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
    margin-top: 0;
    font-size: 36rem;
    line-height: 45rem;
    text-align: left !important;
  }
  .fca5-item .p2{
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
    text-align: left !important;
    margin-top: 0;
    font-size: 28rem;
    line-height: 36rem;
  }
  .fca5-content.is-ar .fca5-item .p1,
  .fca5-content.is-ar .fca5-item .p2 {
    direction: rtl;
    text-align: right;
  }
.fca5 a {
  height: 80rem;
  min-width: 320rem;
  font-size: 28rem;
  line-height: 30rem;
}
  .fca6-img{
    width: 484rem;
  }
  .fca6-content{
    padding-left: 0;
    margin-left: 0;
  }
  .fca6-content .p1{
    margin-top: 50rem;
    font-size: 24rem;
  }
  .fca6-content .p2{
    font-size: 22rem;
    margin-top: 10rem;
  }
  .btn{
    font-size: 24rem;
    padding: 14rem 20rem;
    min-width: 310rem;
  }
}

</style>
<style lang="scss">
/* === section5 流程：从左到右点亮 + 虚线过渡 === */
.fca5-content.fca5-seq .fca5-item {
  /* 按设计图尺寸：图标 134rem，连接线从图标边缘开始 */
  flex: 0 0 134rem;
  width: 134rem;
  overflow: visible;
}

.fca5-line {
  flex: 0 0 180rem;
  width: 180rem;
  height: 134rem;
  position: relative;
  min-width: 180rem;
}

.fca5-line::before,
.fca5-line::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1rem;
  transform: translateY(-50%);
  background-size: 12rem 1rem;
  background-repeat: repeat-x;
}

.fca5-line::before {
  background-image: repeating-linear-gradient(
    to right,
    rgba(0, 0, 0, 0.18) 0 7rem,
    transparent 7rem 12rem
  );
}

.fca5-line::after {
  transform: translateY(-50%) scaleX(0);
  transform-origin: left;
  transition: transform 2400ms ease;
  background-image: none;
  background-color: #a52933;
}

.fca5-line.is-active::after {
  transform: translateY(-50%) scaleX(1);
}

@media (min-width: 997px) {
  .fca5-content.is-ar .fca5-line::after {
    transform-origin: right;
  }
}

/* SVG 内联后对 fill/stroke 做过渡，兼容 1-4 号图标切换红/灰 */
.fca5-item svg {
  width: 134rem;
  height: 134rem;
  display: block;
  margin-bottom: 25rem;
  flex: 0 0 auto;
}
.fca5-item svg path {
  transition: fill 2400ms ease, stroke 2400ms ease, fill-opacity 2400ms ease,
    stroke-opacity 2400ms ease;
}

.fca5-content.is-resetting .fca5-line::after,
.fca5-content.is-resetting .fca5-item svg path {
  transition: none !important;
}

/* 灰色（默认） */
.fca5-item .fca5-svg-core {
  fill: rgba(0, 0, 0, 0.05) !important;
  fill-opacity: 1 !important; /* 统一由 CSS 控制，避免被 SVG 自带 0.05 影响 */
}
.fca5-item .fca5-svg-ring {
  stroke: rgba(0, 0, 0, 0.1) !important;
  stroke-opacity: 1 !important;
}
.fca5-item .fca5-svg-number {
  fill: #6a6967 !important;
}

/* 点亮（红色） */
.fca5-item.is-active .fca5-svg-core {
  fill: #a52933 !important;
  fill-opacity: 1 !important; /* 解决 2-4 号图标“只亮边缘、中间仍灰”的问题 */
}
.fca5-item.is-active .fca5-svg-ring {
  stroke: #a52933 !important;
  stroke-opacity: 1 !important;
}
.fca5-item.is-active .fca5-svg-number {
  fill: #ffffff !important;
}
 @media (max-width:996px){
    .fca5-content {
    width: 100%;
    padding: 0 48rem;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    margin-bottom: 80rem;
  }
  .fca5-content.is-ar {
    direction: ltr;
  }
  .fca5-content.fca5-seq .fca5-item {
    width: 100%;
    flex: 0 0 auto;
    display: grid;
    grid-template-columns: 112rem minmax(0, 1fr);
    grid-template-rows: auto auto;
    align-items: flex-start;
    column-gap: 48rem;
    row-gap: 12rem;
    min-height: 112rem;
  }
  .fca5-item svg {
    width: 112rem;
    height: 112rem;
    margin-bottom: 0;
    grid-column: 1;
    grid-row: 1 / span 2;
  }
  .fca5-line {
    display: block;
    width: 2rem;
    min-width: 2rem;
    flex: 1 0 80rem;
    height: 80rem;
    margin-left: 55rem;
    margin-right: 0;
    align-self: flex-start;
    position: relative;
  }
  .fca5-line::before,
  .fca5-line::after {
    top: 0;
    bottom: 0;
    left: 50%;
    right: auto;
    width: 2rem;
    height: auto;
    transform: translateX(-50%);
    background-size: 2rem 18rem;
    background-repeat: repeat-y;
  }
  .fca5-line::before {
    background-image: repeating-linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.18) 0 10rem,
      transparent 10rem 18rem
    );
  }
  .fca5-line::after {
    transform: translateX(-50%) scaleY(0);
    transform-origin: top;
    background-color: #a52933;
    background-image: none;
  }
  .fca5-line.is-active::after {
    transform: translateX(-50%) scaleY(1);
  }
 }

</style>